// extracted by mini-css-extract-plugin
export default {"messagegmodal":"messagegmodal-oatZf","navRight":"nav-right-RVQI0","close":"close-XJtzx","titlename":"titlename-PRdhC","arrow":"arrow-Y63AZ","arrowIcon":"arrowIcon-NBpJU"};